import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TDateGroupInfo, TSelectFilterGroupInfo } from '../../filter/model/ui-filter.types';

@Component({
  selector: 'ui-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent {
  @Input() filterModel!: TSelectFilterGroupInfo | TDateGroupInfo;

  @Output() selectedFilterEvent = new EventEmitter<TSelectFilterGroupInfo | TDateGroupInfo>();

  dropdownInterfaceOptions = {
    header: undefined,
    size: 'auto',
    showBackdrop: false,
    cssClass: 'pagination-popover',
  };

  onSelectedItemsUpdate($event: Event) {
    const selectedValues: string[] | TDateGroupInfo['items'][number] = ($event as CustomEvent).detail.value;

    const updatedModelInfo = {
      ...this.filterModel,
      selectedValues,
      items: this.filterModel.items.map((v) => {
        if (typeof v.value === 'string' && Array.isArray(selectedValues)) {
          return {
            ...v,
            isSelected: !!selectedValues.find((si) => v.value === si),
          };
        } else {
          const typedSelectedValues = selectedValues as unknown as TDateGroupInfo['items'][number]['value'];
          const value = v as TDateGroupInfo['items'][number];
          return {
            ...value,
            isSelected: !!(typedSelectedValues === value.value),
          };
        }
      }),
    } as TSelectFilterGroupInfo | TDateGroupInfo;
    this.selectedFilterEvent.emit(updatedModelInfo);
  }
}
